import TeamManage from './team_manage.vue';

export default TeamManage;
